module.exports = __webpack_public_path__ + "img/laravel-fullstack-app2.bb908b13.png";